module.exports = "<main>\r\n    <router-outlet></router-outlet>\r\n    <ctm-message></ctm-message>\r\n    <div class=\"api-loading\">\r\n        <div class=\"overlay\"></div>\r\n        <div class=\"spin\">\r\n            <div></div>\r\n        </div>\r\n    </div>\r\n</main>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 790
// module chunks = 63